export default "__VITE_ASSET__4e6ea137__"